import { render } from "./OurClient.vue?vue&type=template&id=324d301c"
import script from "./OurClient.vue?vue&type=script&lang=js"
export * from "./OurClient.vue?vue&type=script&lang=js"

import "./OurClient.vue?vue&type=style&index=0&id=324d301c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__